module.exports = __webpack_public_path__ + "media/music_3.1a445ef9.mp3";